// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28zBA","index":"styles_index__1MPkm"};